import templateUrl from "./user-details.html";
import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";
import moment from "moment";

export const userDetailComponent = {
  bindings: {
    details: "<",
  },
  templateUrl,
  controller: class UserDetailComponent {
    constructor(
      $state,
      $stateParams,
      ApiService,
      AuthService,
      DateService,
      Constants
    ) {
      "ngInject";

      this.$state = $state;
      this.Constants = Constants;
      this.apiService = ApiService;
      this.authService = AuthService;
      this.dateService = DateService;
      this.$stateParams = $stateParams;
    }
    $onInit() {
      const accountDetails = this.authService.getUser();
      // if (this.details.preferredLocations) {
      //   this.details.preferredLocations = this.details.preferredLocations.map(
      //     (location) => location.name
      //   );
      // }
      if (this.details.enrolledInSpecialPrograms) {
        this.formattedDate = this.details.skillbridgeInfo.expectedStartDate
          ? moment(this.details.skillbridgeInfo.expectedStartDate).format(
              "MM-DD-YYYY"
            )
          : "";

        this.formattedETSDate = this.details.etsSponsorshipInfo.enrolledDate
          ? moment(this.details.etsSponsorshipInfo.enrolledDate).format(
              "MM-DD-YYYY"
            )
          : "";

        this.formattedENPPDate = this.details.enppInfo.enrolledDate
          ? moment(this.details.enppInfo.enrolledDate).format("MM-DD-YYYY")
          : "";

        console.log(this.details);

        this.details.enrolledInSpecialPrograms = {
          enpp: this.getYesNoFromBooleanValue(
            this.details.enrolledInSpecialPrograms.enpp
          ),
          etsSponsorship: this.getYesNoFromBooleanValue(
            this.details.enrolledInSpecialPrograms.etsSponsorship
          ),
          skillbridge: this.getYesNoFromBooleanValue(
            this.details.enrolledInSpecialPrograms.skillbridge
          ),
          jobCorps: this.getYesNoFromBooleanValue(
            this.details.enrolledInSpecialPrograms.jobCorps
          ),
        };
      }
      if (this.details.uuid) {
        this.details.profilePicUrl = this.apiService.getImageUrl(
          this.details.uuid
        );
      }
      const phoneUtil = PhoneNumberUtil.getInstance();
      let phoneNumber = this.details.phoneNumber;
      let phoneDialCode = this.details.phoneDialCode;
      if (phoneNumber) {
        const number = phoneUtil.parseAndKeepRawInput(
          phoneNumber,
          this.details.phoneCountryCode
        );
        phoneNumber = phoneUtil.format(number, PhoneNumberFormat.NATIONAL);
        phoneDialCode =
          phoneDialCode.indexOf("+") === -1
            ? `+${phoneDialCode}`
            : phoneDialCode;
        this.details.phoneNumber = `${phoneDialCode} ${phoneNumber}`;
      }
      if (this.details.startDateOfService) {
        this.details.startDateOfService =
          this.dateService.parseDateFromServerDate(
            this.details.startDateOfService
          );
      }
      if (this.details.eosDate) {
        this.details.eosDate = this.dateService.parseDateFromServerDate(
          this.details.eosDate
        );
      }
      this.userRole = accountDetails.role;
      this.isCommandCounselor = this.userRole === "commandCareerCounselor";
      this.isSuperAdmin = this.userRole === "superAdmin";
      this.stagesList = this.details
        ? this.details.steps.filter(
            ({ isSpouseChecklist }) => isSpouseChecklist === false
          )
        : [];
      this.spouseChecklist = this.details
        ? this.details.steps.filter(
            ({ isSpouseChecklist }) => isSpouseChecklist === true
          )
        : [];

      if (this.details) {
        this.details.subscribeToWeeklyNewsletter = this.details
          .subscribeToWeeklyNewsletter
          ? "Yes"
          : "No";
      }
    }
    _onView(routeName, id) {
      this.$state.go(routeName, { id });
    }
    getYesNoFromBooleanValue(value) {
      if (value !== null) {
        return value ? "Yes" : "No";
      }
      return null;
    }
    onStagesClick(timelineId) {
      if (this.isCommandCounselor) {
        const url = `#!/user/${this.$stateParams.id}/stages/${timelineId}/tasks`;
        window.open(url, "_blank");
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/user/user-details/user-details.component.js